import { authRoutes } from '@/features/auth/authRoutes.js'
import { clubIdSetterGuard } from '@/features/auth/guards/clubIdSetterGuard.js'
import { clubRegisterRoutes } from '@/features/clubRegister/clubRegisterRoutes.js'
import { devRoutes } from '@/features/devMode/devRoutes.js'
import { embedRoutes } from '@/features/embed/embedRoutes.js'
import InitProject from '@/features/layout/InitProject.vue'
import { noAccessRoutes } from '@/features/noAccess/noAccessRoutes.js'
import { clubRoutes } from '@/features/router/clubRoutes.js'
import { superAdminRoutes } from '@/features/superAdmin/superAdminRoutes.js'
import NotFoundView from '@/features/views/NotFound/NotFoundView.vue'

import ErrorView from '../error/ErrorView.vue'

export const routes = [
  {
    path: '/',
    name: 'init-project',
    component: InitProject,
    beforeEnter: [clubIdSetterGuard],
    children: [
      ...clubRoutes,
      ...authRoutes,
      ...superAdminRoutes,
      ...clubRegisterRoutes,
      ...devRoutes,
      ...noAccessRoutes,

      { path: 'error', name: 'error', component: ErrorView },
      { path: ':pathMatch(.*)*', name: 'not-found', component: NotFoundView },
    ],
  },
  ...embedRoutes,
].filter(Boolean)
